import { render, staticRenderFns } from "./update-team-form.vue?vue&type=template&id=3af78c6a&scoped=true&"
import script from "./update-team-form.vue?vue&type=script&lang=ts&"
export * from "./update-team-form.vue?vue&type=script&lang=ts&"
import style0 from "./update-team-form.vue?vue&type=style&index=0&id=3af78c6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af78c6a",
  null
  
)

export default component.exports